export default __webpack_public_path__ + "static/media/1_7_logo.39d9c23e.png";